<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Rxdb WayPoints</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #pathWayPointForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr *ngIf="tmpPathWayPoint?._id">
                    <th>ID</th>
                    <td>{{tmpPathWayPoint?._id}}</td>
                </tr>
                <tr>
                    <th>Path ID</th>
                    <td>
                        <input size=70 name="pathId" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.pathId" #pathId="ngModel" required pathId
                            [ngClass]="{ 'invalid-input': pathId.invalid && (pathId.dirty || pathId.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>point ID</th>
                    <td>
                        <input size=70 name="pointId" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.pointId" #pointId="ngModel" required
                            [ngClass]="{ 'invalid-input': pointId.invalid && (pointId.dirty || pointId.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>From Point ID</th>
                    <td>
                        <input size=70 name="fromPointId" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.fromPointId" #fromPointId="ngModel" required
                            [ngClass]="{ 'invalid-input': fromPointId.invalid && (fromPointId.dirty || fromPointId.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Waypoint Order</th>
                    <td>
                        <input size=70 id="waypointOrder" name="waypointOrder" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.waypointOrder" #waypointOrder="ngModel" required
                            [ngClass]="{ 'invalid-input': waypointOrder.invalid && (waypointOrder.dirty || waypointOrder.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Segment</th>
                    <td>
                        <input size=70 id="segment" name="segment" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.segment" #segment="ngModel"
                            [ngClass]="{ 'invalid-input': segment.invalid && (segment.dirty || segment.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td>
                        <input size=70 id="type" name="type" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPathWayPoint.type" #type="ngModel"
                            [ngClass]="{ 'invalid-input': type.invalid && (type.dirty || type.touched)}" >
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button  (click)="onSave()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
